import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { ListingToolCall } from '../types';

interface ListingCard extends LinkCardRecord {
  address: string | null;
  displayName: string;
  listingType: string | null;
  status: string;
}

interface ListingCardsProps {
  toolCalls: ListingToolCall[];
}

export function ListingCards({ toolCalls }: ListingCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path}>
          {(listing: ListingCard) => (
            <>
              <div className="fw-semibold text-truncate">{listing.displayName}</div>
              {listing.address && <div className="small text-muted text-truncate">{listing.address}</div>}
              <div className="d-flex align-items-center gap-1">
                <Badge appearance="muted" variant="secondary">{listing.status}</Badge>
                {listing.listingType && <span className="small text-muted">{listing.listingType}</span>}
              </div>
            </>
          )}
        </LinkCard>
      ))}
    </>
  );
}
